import React from 'react';

function GooglePlayButton(props){
  return (
    <>
			<div style={{display: 'inline-block'}}>
				<a target='_blank' href={props.storeLink}><img style={{height: props.size + 'px'}} alt={props.alt} src={props.imgSource}/></a>
			</div>
    </>
  );
};

GooglePlayButton.defaultProps = {
	alt: 'Get it on Google Play',
	imgSource: 'https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg',
	storeLink: 'https://play.google.com/store/apps/details?id=app.cryptowaves.mobile&hl=en&gl=US&pli=1&utm_source=landing&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
	size: 50
};

export default GooglePlayButton;